import { StoryblokIcon } from '@cinch-nx/landing-ui-storyblok-icon'
import { StoryBenefitsEvCard } from '../../types/electric-cars-page'
import styles from './ev-info-card.module.css'
interface EvInfoCardProps {
  evInfo: StoryBenefitsEvCard[]
}

export const EvInfoCard = ({ evInfo }: EvInfoCardProps) => {
  const { icon, title, text } = evInfo[0]
  return (
    <div className={styles.cardContainer}>
      <div className={styles.iconTitleContainer}>
        <StoryblokIcon iconName={icon} size={24} />
        <h3>{title}</h3>
      </div>
      <p className={styles.text}>{text}</p>
    </div>
  )
}
